.footer {
  bottom: 0;
  margin-right: calc(-1 * var(--rc-theme-react-components-modal-scrollable-padding-lg));
  margin-left: calc(-1 * var(--rc-theme-react-components-modal-scrollable-padding-lg));
  padding-right: var(--rc-theme-react-components-modal-scrollable-padding-lg);
  padding-left: var(--rc-theme-react-components-modal-scrollable-padding-lg);
  border-top: 1px solid var(--rc-theme-color-border-default);
}

.footer--padding-top {
  padding-top: var(--rc-theme-react-components-modal-scrollable-padding-lg);
}

.footer--padding-bottom {
  padding-bottom: var(--rc-theme-react-components-modal-scrollable-padding-lg);
}
